import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ServiceType } from '@mews-commander/data-access';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Product/Index/')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    loaderDeps: ({ search: { OwnerId } }) => ({ OwnerId }),
    loader: async ({
        params: { currentEnterpriseId },
        context: { ensureQueryData, featureFlagService },
        deps: { OwnerId: serviceId },
    }) => {
        const isNewProductListViewEnabled = featureFlagService.hasFlag(FeatureFlag.feProductListViewEnabled);

        if (isNewProductListViewEnabled) {
            const { services } = await ensureQueryData('services', 'getAll', {
                serviceIds: [serviceId],
                enterpriseIds: [currentEnterpriseId],
            });

            if (services[0]?.data.discriminator === ServiceType.Bookable) {
                throw redirect({
                    to: '/$currentEnterpriseId/Settings/Services/$serviceId/Products',
                    params: { currentEnterpriseId, serviceId },
                });
            }
        }
    },
    component: BackendPageComponent,
    staticData: {
        routeName: RouteName.ProductIndex,
        owner: MewsTeam.RevenueServices,
        type: RouteType.Backend,
        guideLink: createGuideLink(ArticlePath.UnderstandingServices),
    },
});

function BackendPageComponent() {
    const { pathname, search } = Route.useMatch();

    return <BackendPage url={getBackendPageUrl({ pathname, search })} />;
}
